export default __webpack_public_path__ + "54a2e8fbcd758ef802a53eb9814e572d.png";